import { clsx } from "clsx";
import shallow from "zustand/shallow";

import { Slider } from "../SVGasComponent/Slider";
import styles from "./proModeSlider.module.scss";
import { useStoreSystem } from "../../store";



export const ProModeSlider = () => {

    const { setSystemProperties, proMode } = useStoreSystem(state => ({
        setSystemProperties: state.setSystemProperties,
        proMode: state.proMode,
    }), shallow);

    const handlerClick = () => {
        setSystemProperties([
            { name: 'proMode', value: !proMode },
        ])
    }

    return (
        <div className={clsx(styles.main, !proMode && styles.main_disable)}>
            <div className={clsx(styles.slider, !proMode && styles.slider_off)} >
                <div className={clsx(styles.text, styles.text_enable)}>Pro</div>
                <div className={styles.sliderBox} >
                    <div className={styles.sliderSVG} onClick={handlerClick}>
                        <Slider on={proMode} />
                    </div>
                </div>
                <div className={clsx(styles.text, styles.text_disable)}>Pro</div>
            </div>
        </div>
    )
}